import { GetServerSideProps } from 'next';

import { Moments } from '@/features/Moments';
import { api } from '@/features/Moments/api';
import {
  MomentId,
  MomentsDataType,
} from '@/features/Moments/moments.types';

import { RequestResponse } from '@/utils/request.types';
import { withNavigationData } from '@/utils/withNavigationData';

type PageProps = {
  config: {
    momentsData: RequestResponse<Array<MomentId>>;
    pageData: RequestResponse<MomentsDataType>;
  };
};

const Page = ({ config }: PageProps) => (
  <Moments
    momentsData={config.momentsData}
    pageData={config.pageData}
  />
);

export const getServerSideProps: GetServerSideProps = withNavigationData(async context => {
  let config;
  const { locale } = context;

  try {
    const PageData = await api.getMomentsPage({ locale: context.locale });

    const MomentsData = await api.getMoments({
      locale,
      'pagination[page]': 1,
      'pagination[pageSize]': 24,
    });

    config = {
      momentsData: MomentsData.data,
      pageData: PageData.data,
    };
  } catch (error) {
    return {
      redirect: {
        destination: `/${context.locale}/404`,
        permanent: true,
      },
    };
  }

  return {
    props: {
      config,
    },
  };
});
export default Page;
